import React from 'react';
import { SkeletonCircle, SkeletonRectangle } from '@kiiwi/ui';

type Props = {
  nbrSkeleton: number;
};

const TLCSkeleton = ({ nbrSkeleton }: Props) => (
  <div className="flex flex-col gap-3">
    <div className="mb-3 flex w-full flex-col gap-2">
      <SkeletonRectangle className="h-6 w-3/4 sm:w-1/3" />
      <SkeletonRectangle className="h-5 w-5/6 sm:w-2/5" />
    </div>
    {Array.from({ length: nbrSkeleton }).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <div className="flex gap-4 p-3" key={index}>
        <SkeletonCircle size="xl" className="hidden sm:block" />
        <div className="flex flex-[2] flex-col gap-2 sm:gap-3">
          <div className="flex gap-2 sm:gap-3">
            <div className="flex-shrink-0 sm:hidden">
              <SkeletonCircle size="md" />
            </div>
            <div className="flex flex-1 flex-col gap-2 sm:gap-3">
              <SkeletonRectangle className="h-5 w-5/6 sm:h-6" />
              <SkeletonRectangle className="h-4 w-2/3 sm:h-5" />
            </div>
          </div>
          <SkeletonRectangle className="h-4 w-1/2 sm:h-5" />
          <SkeletonRectangle className="h-4 w-28 rounded" />
        </div>
        <SkeletonRectangle className="h-auto w-auto flex-1 sm:w-[216px]" />
      </div>
    ))}
  </div>
);
export default TLCSkeleton;
